import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/compras";

export const Route = createFileRoute("/_authenticated/compras")({
  head: () => ({
    meta: [
      { title: "Compras — Milky Moo Palmares" },
      {
        name: "description",
        content: "Listas de compras, fornecedores e notas fiscais de entrada.",
      },
      { property: "og:title", content: "Compras — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Listas de compras, fornecedores e notas fiscais de entrada.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
